export const MAX_BYTES_PER_SEND = 5_368_709_120;
export const MAX_ITEMS_PER_LINK = 100;

export const MAX_RECIPIENTS = 50;
